import React from "react";
import { Col, Row } from "antd";
import UserPhoto from "../../../commons/components/userPhoto";

export default ({ userData }) => {
    return (
        <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ marginRight: 24 }}>
                        <UserPhoto width={100} height={100} />
                    </div>

                    <div>
                        <h2 className={"dados-header"}>Olá, {userData.user_name}</h2>
                        <span className={"dados-header-subtitle"}>Gerencie as suas informações que serão utilizadas nas plataformas Sankhya.</span>
                    </div>
                </div>
            </Col>
        </Row>
    )
}
